import { type MovementDto } from "@modules/profile/publicProfile/gateway/publicProfileDto"
import { Modality } from "@modules/profile/publicProfile/types/publicProfileTypes"
import { ScoreType } from "@modules/scores/scoreTypes"

export class MovementEntity {
  id: string
  movementName: string
  description: string
  modality: Modality
  scoreType: ScoreType
  videoUrl: string | null

  private constructor(entity: MovementEntity) {
    this.id = entity.id
    this.movementName = entity.movementName
    this.description = entity.description
    this.modality = entity.modality
    this.scoreType = entity.scoreType
    this.videoUrl = entity.videoUrl
  }

  static fromDto(dto: MovementDto): MovementEntity {
    return new MovementEntity({
      id: dto.id,
      movementName: dto.movementName,
      description: dto.description,
      modality: dto.modality,
      scoreType: dto.scoreType,
      videoUrl: dto.videoUrl ?? null,
    })
  }
}
